// 当前选中的二级菜单ID
const activeLv2Id = [];
// axjx请求的页码
const scrollPage = 1;
// 一级菜单v-model值，用于轮播定位
const lv1ActiveItem = null;
// 用于搜索结果分类导航定位
const searchResultModel = 0;

export default {
    activeLv2Id,
    scrollPage,
    lv1ActiveItem,
    searchResultModel
}
